import { Plan } from '@faceup/utils'

/**
 * I think this whole hook can be replaced with one boolean field in GQL on ReportSource.
 */
export const useIsCheckReportAvailable = ({
  plan,
}: {
  plan: Plan | null | undefined
}): {
  isCheckReportAvailable: boolean
} => ({
  isCheckReportAvailable: plan ? ![Plan.Unregistered, Plan.Free].includes(plan) : true,
})
